import 'whatwg-fetch';
import {
	getParams, buildQuery, setHistory, doSearch, setExisitngValues,
} from './params.js';
import { emPagination } from './pagination.js';
import initAutoComplete from './autocomplete.js';

const initDoctorFinder = (el, params) => {
	if (!el) {
		return;
	}
	const { restUrl } = window.EmClient;
	const resultsCount = el.querySelector('.em-doctor-finder__result-count span');
	const resultsContainer = el.querySelector('.em-doctor-finder__results');

	const scrollToResults = (el) => {
		const container = el.getBoundingClientRect();
		const header = document.querySelector('.site-header');
		document.documentElement.scrollTop = container.top - header.clientHeight + window.scrollY - 130;
	};

	(async () => {
		const response = await fetch(`${restUrl}wp/v2/em-people${buildQuery(params)}`);
		const { headers } = response;
		const totalPosts = headers.get('X-WP-Total');
		const totalPages = headers.get('X-WP-TotalPages');
		const data = await response.json();

		resultsCount.innerHTML = totalPosts;

		if (data.length > 0) {
			let listItems = '';
			data.forEach((item) => {
				listItems += item.partial;
			});

			const pagination = emPagination(totalPages, params.page || 1, 5);

			resultsContainer.innerHTML = listItems + pagination;

			const pageNumbers = el.querySelectorAll('.page-numbers');

			// Loop through page numbers.
			pageNumbers.forEach((page) => {
				page.onclick = function () {
					const params = getParams();
					params.page = this.dataset.page;
					scrollToResults(resultsContainer);
					initDoctorFinder(el, params);
					setHistory(params);
				};
			});
		} else {
			const { noResults } = window.emOptions;
			resultsContainer.innerHTML = noResults;
		}
	})();
};

const loadFinder = () => {
	const params = getParams();
	const finder = document.querySelector('.em-doctor-finder');
	if (!finder) {
		return;
	}
	setExisitngValues(finder, params);
	initDoctorFinder(finder, params);
};

document.addEventListener('DOMContentLoaded', () => {
	loadFinder();
	doSearch(initDoctorFinder);
	initAutoComplete();
});

window.addEventListener('popstate', () => {
	loadFinder();
});
